export function getIsNativeApp(): boolean {
  // Phone app: Connect runs in a webview. Tablet app: it opens /marketing?hidemenu=1, which
  // App.isApp reads from the URL (not localStorage, which keeps `hidemenu` forever).
  return App.isWebview() || App.isApp(window.location, window.navigator.userAgent);
}
